module.exports = __webpack_public_path__ + "img/pull-down-default-active.fed156b8.svg";